import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Modal,
  Tabs,
  Button,
  Icon,
  Row,
  Col,
  Spin,
  Tooltip,
  Checkbox
} from 'antd';
import ReactTimerStopwatch from 'react-stopwatch-timer';
import _ from 'lodash';
import {
  USER_FILTERS_FORM_NAME,
  IMAGE_FILTER_KEY_NAME,
  DOMAIN_FILTER_KEY_NAME,
  REVIEW_FILTER_KEY_NAME,
  QUALITY_FILTER_KEY_NAME,
  SOCIAL_MEDIA_FILTER_KEY_NAME
} from '../AdminPageConstants';

const { TextArea } = Input;
const { TabPane } = Tabs;

class UserFiltersForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCheckboxData: [],
      filterData: {},
      checkboxLimit: 3,
      activeCheckboxClick: false
    };
  }

  handleRegister = (event) => {
    const filters = this.state.filterData;
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onCreate(values, filters);
      }
    });
  };

  onCancel = () => {
    const form = this.props.form;
    form.resetFields();
    this.props.onCancel();
  };

  renderFilters = (
    filterType,
    preparedImagesFiltersData,
    preparedDomainsFiltersData,
    preparedReviewFiltersData,
    preparedQualityControlFiltersData
  ) => {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const actualData =
      preparedImagesFiltersData ||
      preparedDomainsFiltersData ||
      preparedReviewFiltersData ||
      preparedQualityControlFiltersData;
    const chacheInfo = _.map(
      actualData,
      (item) => item.workFilterDto.workFilterResultCount
    );
    // let preparedFiltersData = _.orderBy(_.filter(this.props.userData.filters, (filter) => (filter.type === filterType)), ['orderIndex'], ['asc'])

    // getFieldDecorator(`${filterType.toLocaleLowerCase()}_keys`, { initialValue: preparedFiltersData })
    // getFieldDecorator(`${filterType.toLocaleLowerCase()}_last_order_index`, {
    //   initialValue: preparedFiltersData.length > 0 ? preparedFiltersData[preparedFiltersData.length - 1].orderIndex : 0,
    // })
    const keys = getFieldValue(`${filterType.toLocaleLowerCase()}_keys`);
    return _.map(keys, (ft, index) => {
      const fromTime = new Date(0, 0, 0, 0, 0, 0, 0);
      let runQueryData = null;

      let createdBy = actualData[index] ? actualData[index].createdBy : null;
      let isActiveData = actualData[index] ? actualData[index].active : false;
      let createdAt = null;

      if (actualData[index] && actualData[index].createdAt) {
        let createdAtDate = new Date(actualData[index].createdAt);
        createdAt = createdAtDate.toString().substring(4, 24);
      }

      if (this.props.runQueriesData.hasOwnProperty(filterType)) {
        runQueryData = _.find(this.props.runQueriesData[filterType], {
          queryKey: `${filterType.toLowerCase()}_sql_${ft.orderIndex}`
        });
      }

      let isChecked = isActiveData;

      if (this.state.filterData && this.state.filterData[filterType]) {
        let filterState = this.state.filterData[filterType];
        isChecked = filterState.indexOf(ft.orderIndex) >= 0 ? true : false;
      }

      const currentData = actualData[index];

      if (currentData && !this.state.activeCheckboxClick) {
        if (currentData.active) {
          const filterDataState = this.state.filterData;
          const type = currentData.type;
          const order = currentData.orderIndex;

          if (!filterDataState[type]) {
            let state = { ...filterDataState };
            let array = [order];
            state[filterType] = array;
            this.setState({
              filterData: state
            });
          }

          if (filterDataState[type]) {
            let currentFilter = filterDataState[type];
            let state = { ...filterDataState };

            if (
              currentFilter.length < this.state.checkboxLimit &&
              currentFilter.indexOf(order) < 0
            ) {
              currentFilter = [...currentFilter, order];
              state[filterType] = currentFilter;

              this.setState({
                filterData: state
              });
            }
          }
        }
      }

      return (
        <Row
          key={`${filterType.toLowerCase()}_sql_${ft.orderIndex}`}
          className='no-bottom-margin'
        >
          <Spin
            spinning={runQueryData ? runQueryData.runStatus : false}
            indicator={
              <ReactTimerStopwatch
                isOn={runQueryData ? runQueryData.runStatus : false}
                displayCricle={true}
                className='react-stopwatch-timer__table'
                watchType='stopwatch'
                fromTime={fromTime}
                displayHours={false}
              />
            }
          >
            <Col span={20}>
              <Form.Item>
                {getFieldDecorator(
                  `${filterType.toLowerCase()}_description_${ft.orderIndex}`,
                  {
                    initialValue: ft.description
                  }
                )(<Input />)}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator(
                  `${filterType.toLowerCase()}_sql_${ft.orderIndex}`,
                  {
                    initialValue: ft.query,
                    rules: [
                      {
                        required: true,
                        message: 'This field cannot be empty.'
                      }
                    ]
                  }
                )(<TextArea rows={7} />)}
              </Form.Item>
              <div className='info-wrapper' style={{ display: 'flex' }}>
                {runQueryData && !_.isEmpty(runQueryData.queryResult) && (
                  <div>Query count: {runQueryData.queryResult.count}</div>
                )}
                <div style={{ marginLeft: '12px' }}>
                  Cache results count: {chacheInfo[index]}
                </div>
              </div>
              {/*{runQueryData && <div>Query count: {runQueryData.queryResult}</div>}*/}
            </Col>
            <Col span={4}>
              <div className='filter-actions-buttons'>
                <div
                  onClick={() =>
                    this.runTestQuery(filterType, ft.orderIndex, 'check')
                  }
                  className='filter-actions-buttons-content'
                >
                  <Icon className='dynamic-button' type='right-circle' />
                  <span style={{ marginLeft: 8 }}>Test query</span>
                </div>
                <Tooltip
                  placement='top'
                  title='Please note that processing time might be up to 10 minutes, based on the complexity of the request.'
                  key={`${filterType.toLowerCase()}_sql_${ft.orderIndex}`}
                >
                  <div
                    onClick={() =>
                      this.runTestQuery(filterType, ft.orderIndex, 'execute')
                    }
                    className='filter-actions-buttons-content'
                  >
                    <Icon className='dynamic-button' type='right-circle' />
                    <span style={{ marginLeft: 8 }}>Execute query</span>
                  </div>
                </Tooltip>
                <div
                  onClick={() =>
                    this.removeDynamicField(filterType, ft.orderIndex)
                  }
                  className='filter-actions-buttons-content'
                >
                  <Icon className='dynamic-button' type='minus-circle-o' />
                  <span style={{ marginLeft: 8 }}>Remove field</span>
                </div>

                <Checkbox
                  className='filter-actions-checkbox-content'
                  checked={isChecked}
                  onClick={(event) =>
                    this.handleCheckboxFilter(event, filterType, ft.orderIndex)
                  }
                >
                  {isChecked ? <span>Active</span> : <span>Inactive</span>}
                </Checkbox>

                <Tooltip
                  placement='top'
                  title={`Created At: ${createdAt}`}
                  key={`${filterType.toLowerCase()}_sql_${ft.orderIndex}`}
                >
                  <div className='filter-actions-buttons-content'>
                    <span style={{ marginLeft: 8 }}>
                      Created By: {createdBy}
                    </span>
                  </div>
                </Tooltip>
              </div>
            </Col>
          </Spin>
        </Row>
      );
    });

    // this.setState({
    //   [filterType]: preparedFiltersData.length > 0 ? preparedFiltersData.length - 1 : 0,
    // }, () => {
    //
    // })
  };

  runTestQuery = (filterType, index, status = 'check') => {
    const { getFieldValue } = this.props.form;

    let query = getFieldValue(`${filterType.toLowerCase()}_sql_${index}`);
    const keys = getFieldValue(`${filterType.toLocaleLowerCase()}_keys`);
    let temp = _.find(keys, { orderIndex: index });

    this.props.checkAndGetQueryResult(
      query,
      filterType,
      temp,
      `${filterType.toLowerCase()}_sql_${index}`,
      status
    );
  };

  removeDynamicField = (filterType, orderIndex) => {
    const { setFieldsValue, getFieldValue } = this.props.form;
    const keys = getFieldValue(`${filterType.toLocaleLowerCase()}_keys`);
    let preparedKeys = _.cloneDeep(keys);
    // const lastOrderIndex = getFieldValue(`${filterType.toLocaleLowerCase()}_last_order_index`)
    let index = _.findIndex(preparedKeys, { orderIndex: orderIndex });
    preparedKeys.splice(index, 1);
    let sortedKeys = _.orderBy(preparedKeys, ['orderIndex'], ['desc']);

    setFieldsValue({
      [`${filterType.toLocaleLowerCase()}_keys`]: preparedKeys
    });
    setFieldsValue({
      [`${filterType.toLocaleLowerCase()}_last_order_index`]: !_.isEmpty(
        sortedKeys
      )
        ? sortedKeys[0].orderIndex
        : 0
    });
  };

  handleCheckboxFilter = (event, filterType, orderIndex) => {
    let isSelected = null;

    this.setState({
      activeCheckboxClick: true
    });

    if (event && event.currentTarget) isSelected = event.currentTarget.checked;
    else isSelected = event;

    const filterDataState = this.state.filterData;
    const filtersLimit = this.state.checkboxLimit;

    if (isSelected) {
      // if this filter not found in filters
      if (!filterDataState[filterType]) {
        let state = { ...filterDataState };
        let array = [orderIndex];
        state[filterType] = array;
        this.setState({
          filterData: state
        });
      }

      // fi this filter already exist
      if (filterDataState[filterType]) {
        let currentFilter = filterDataState[filterType];
        let state = { ...filterDataState };

        if (currentFilter.length < filtersLimit) {
          currentFilter = [...currentFilter, orderIndex];
          state[filterType] = currentFilter;

          this.setState({
            filterData: state
          });
        }
      }
    } else {
      if (filterDataState[filterType]) {
        let state = { ...filterDataState };
        let stateArray = filterDataState[filterType];
        state[filterType] = stateArray.filter((item) => orderIndex !== item);

        this.setState({
          filterData: state
        });
      }
    }
  };

  addDynamicField = (filterType, start = false) => {
    const { setFieldsValue, getFieldValue } = this.props.form;
    const keys = getFieldValue(`${filterType.toLocaleLowerCase()}_keys`);
    const lastOrderIndex = getFieldValue(
      `${filterType.toLocaleLowerCase()}_last_order_index`
    );

    let nextKeys = [];

    if (start) {
      keys.unshift({
        id: null,
        orderIndex: lastOrderIndex,
        type: filterType,
        query: ''
      });
      nextKeys = keys.map((item, index) => {
        item.orderIndex = index;
        return item;
      });
    } else {
      nextKeys = keys.concat({
        id: null,
        orderIndex: keys.length,
        type: filterType,
        query: ''
      });
    }

    setFieldsValue({
      [`${filterType.toLocaleLowerCase()}_keys`]: nextKeys
    });
    setFieldsValue({
      [`${filterType.toLocaleLowerCase()}_last_order_index`]: lastOrderIndex + 1
    });
  };

  renderCacheImagesFilter = () => {
    return;
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    if (!this.props.isVisible) return null;

    let preparedImagesFiltersData = _.orderBy(
      _.filter(
        this.props.filterData,
        (filter) => filter.type === IMAGE_FILTER_KEY_NAME
      ),
      ['orderIndex'],
      ['asc']
    );
    let preparedDomainsFiltersData = _.orderBy(
      _.filter(
        this.props.filterData,
        (filter) => filter.type === DOMAIN_FILTER_KEY_NAME
      ),
      ['orderIndex'],
      ['asc']
    );
    let preparedReviewFiltersData = _.orderBy(
      _.filter(
        this.props.filterData,
        (filter) => filter.type === REVIEW_FILTER_KEY_NAME
      ),
      ['orderIndex'],
      ['asc']
    );
    let preparedQualityControlFiltersData = _.orderBy(
      _.filter(
        this.props.filterData,
        (filter) => filter.type === QUALITY_FILTER_KEY_NAME
      ),
      ['orderIndex'],
      ['asc']
    );
    let preparedSocialMediaFiltersData = _.orderBy(
      _.filter(
        this.props.filterData,
        (filter) => filter.type === SOCIAL_MEDIA_FILTER_KEY_NAME
      ),
      ['orderIndex'],
      ['asc']
    );

    getFieldDecorator(`${IMAGE_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`, {
      initialValue: preparedImagesFiltersData
    });
    getFieldDecorator(
      `${IMAGE_FILTER_KEY_NAME.toLocaleLowerCase()}_last_order_index`,
      {
        initialValue:
          preparedImagesFiltersData.length > 0
            ? preparedImagesFiltersData[preparedImagesFiltersData.length - 1]
                .orderIndex
            : 0
      }
    );
    getFieldDecorator(`${DOMAIN_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`, {
      initialValue: preparedDomainsFiltersData
    });
    getFieldDecorator(
      `${DOMAIN_FILTER_KEY_NAME.toLocaleLowerCase()}_last_order_index`,
      {
        initialValue:
          preparedDomainsFiltersData.length > 0
            ? preparedDomainsFiltersData[preparedDomainsFiltersData.length - 1]
                .orderIndex
            : 0
      }
    );
    getFieldDecorator(`${REVIEW_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`, {
      initialValue: preparedReviewFiltersData
    });
    getFieldDecorator(
      `${REVIEW_FILTER_KEY_NAME.toLocaleLowerCase()}_last_order_index`,
      {
        initialValue:
          preparedReviewFiltersData.length > 0
            ? preparedReviewFiltersData[preparedReviewFiltersData.length - 1]
                .orderIndex
            : 0
      }
    );
    getFieldDecorator(`${QUALITY_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`, {
      initialValue: preparedQualityControlFiltersData
    });
    getFieldDecorator(
      `${QUALITY_FILTER_KEY_NAME.toLocaleLowerCase()}_last_order_index`,
      {
        initialValue:
          preparedQualityControlFiltersData.length > 0
            ? preparedQualityControlFiltersData[
                preparedQualityControlFiltersData.length - 1
              ].orderIndex
            : 0
      }
    );
    getFieldDecorator(
      `${SOCIAL_MEDIA_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`,
      {
        initialValue: preparedSocialMediaFiltersData
      }
    );
    getFieldDecorator(
      `${SOCIAL_MEDIA_FILTER_KEY_NAME.toLocaleLowerCase()}_last_order_index`,
      {
        initialValue:
          preparedSocialMediaFiltersData.length > 0
            ? preparedSocialMediaFiltersData[
                preparedSocialMediaFiltersData.length - 1
              ].orderIndex
            : 0
      }
    );

    return (
      <Modal
        width={800}
        title={
          <div className='modal-filter-title'>
            <span>Edit filter form for - {this.props.userData.email}</span>
            <span>
              * All queries must be tested before saving. Incorrect queries will
              not be saved.
            </span>
          </div>
        }
        okText='Create'
        cancelText='Cancel'
        visible={this.props.isVisible}
        onOk={this.handleRegister}
        onCancel={this.onCancel}
        keyboard={false}
        maskClosable={false}
      >
        <Form layout='vertical' prefixCls='add_new_user_'>
          <Tabs defaultActiveKey='1' type='card'>
            <TabPane tab='Filters for Images' key='1'>
              {this.renderFilters(
                IMAGE_FILTER_KEY_NAME,
                preparedImagesFiltersData
              )}
              <Form.Item>
                <Button
                  className='add-field'
                  onClick={() => this.addDynamicField(IMAGE_FILTER_KEY_NAME)}
                >
                  <Icon type='vertical-align-bottom' /> Add field
                </Button>
                <Button
                  className='add-field'
                  onClick={() =>
                    this.addDynamicField(IMAGE_FILTER_KEY_NAME, true)
                  }
                  style={{
                    marginLeft: '12px'
                  }}
                >
                  <Icon type='vertical-align-top' /> Add field
                </Button>
              </Form.Item>
            </TabPane>
            <TabPane tab='Filters for Domains' key='2'>
              {this.renderFilters(
                DOMAIN_FILTER_KEY_NAME,
                preparedDomainsFiltersData
              )}
              <Form.Item>
                <Button
                  className='add-field'
                  onClick={() => this.addDynamicField(DOMAIN_FILTER_KEY_NAME)}
                >
                  <Icon type='vertical-align-bottom' /> Add field
                </Button>
                <Button
                  className='add-field'
                  onClick={() =>
                    this.addDynamicField(DOMAIN_FILTER_KEY_NAME, true)
                  }
                  style={{
                    marginLeft: '12px'
                  }}
                >
                  <Icon type='vertical-align-top' /> Add field
                </Button>
              </Form.Item>
            </TabPane>
            <TabPane tab='Filters for Quality Control' key='4'>
              {this.renderFilters(
                QUALITY_FILTER_KEY_NAME,
                preparedQualityControlFiltersData
              )}
              <Form.Item>
                <Button
                  className='add-field'
                  onClick={() => this.addDynamicField(QUALITY_FILTER_KEY_NAME)}
                >
                  <Icon type='vertical-align-bottom' /> Add field
                </Button>
                <Button
                  className='add-field'
                  onClick={() =>
                    this.addDynamicField(QUALITY_FILTER_KEY_NAME, true)
                  }
                  style={{
                    marginLeft: '12px'
                  }}
                >
                  <Icon type='vertical-align-top' /> Add field
                </Button>
              </Form.Item>
            </TabPane>
            <TabPane tab='Filters for Social Media QC' key='5'>
              {this.renderFilters(
                SOCIAL_MEDIA_FILTER_KEY_NAME,
                preparedSocialMediaFiltersData
              )}
              <Form.Item>
                <Button
                  className='add-field'
                  onClick={() =>
                    this.addDynamicField(SOCIAL_MEDIA_FILTER_KEY_NAME)
                  }
                >
                  <Icon type='vertical-align-bottom' /> Add field
                </Button>
                <Button
                  className='add-field'
                  onClick={() =>
                    this.addDynamicField(SOCIAL_MEDIA_FILTER_KEY_NAME, true)
                  }
                  style={{
                    marginLeft: '12px'
                  }}
                >
                  <Icon type='vertical-align-top' /> Add field
                </Button>
              </Form.Item>
            </TabPane>
            <TabPane tab='Filters for Review' key='3'>
              {this.renderFilters(
                REVIEW_FILTER_KEY_NAME,
                preparedReviewFiltersData
              )}
              <Form.Item>
                <Button
                  className='add-field'
                  onClick={() => this.addDynamicField(REVIEW_FILTER_KEY_NAME)}
                >
                  <Icon type='vertical-align-bottom' /> Add field
                </Button>
                <Button
                  className='add-field'
                  onClick={() =>
                    this.addDynamicField(REVIEW_FILTER_KEY_NAME, true)
                  }
                  style={{
                    marginLeft: '12px'
                  }}
                >
                  <Icon type='vertical-align-top' /> Add field
                </Button>
              </Form.Item>
            </TabPane>
          </Tabs>
        </Form>
      </Modal>
    );
  }
}

UserFiltersForm.propTypes = {
  userData: PropTypes.object.isRequired,
  filterData: PropTypes.array.isRequired,
  runQueriesData: PropTypes.object,
  isVisible: PropTypes.bool,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  checkAndGetQueryResult: PropTypes.func,
  checkQuery: PropTypes.func,
  madeQueries: PropTypes.array
};

export default Form.create({ name: USER_FILTERS_FORM_NAME })(UserFiltersForm);
